'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var ImageFallbackSvg = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(SvgIcon, _extends({
        fill: "none",
        height: 24,
        viewBox: "0 0 24 24",
        width: 24
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            clipRule: "evenodd",
            d: "M23.7775 1.5727C24.0741 1.86934 24.0741 2.3503 23.7775 2.64694L22.5242 3.90021L23.7775 5.15349C24.0741 5.45013 24.0741 5.93109 23.7775 6.22773C23.4808 6.52437 22.9999 6.52437 22.7032 6.22773L21.45 4.97445L20.1967 6.22773C19.9 6.52437 19.4191 6.52437 19.1224 6.22773C18.8258 5.93108 18.8258 5.45013 19.1224 5.15349L20.3757 3.90021L19.1225 2.64694C18.8258 2.3503 18.8258 1.86934 19.1225 1.5727C19.4191 1.27606 19.9001 1.27606 20.1967 1.5727L21.45 2.82597L22.7032 1.5727C22.9999 1.27606 23.4808 1.27606 23.7775 1.5727ZM3.74725 3H15.5171C15.4729 3.29362 15.45 3.59421 15.45 3.90015C15.45 7.21385 18.1363 9.90014 21.45 9.90014C22.3618 9.90014 23.2261 9.69676 24 9.33287V17.3219C24 19.7159 22.6923 21 20.2527 21H3.74725C1.2967 21 0 19.7159 0 17.311V6.67812C0 4.28408 1.2967 3 3.74725 3ZM8.45055 11.5435C7.0989 11.5435 5.94505 10.4009 5.94505 9.06243C5.94505 7.69129 7.0989 6.54868 8.45055 6.54868C9.82418 6.54868 10.967 7.69129 10.967 9.06243C10.967 10.4009 9.82418 11.5435 8.45055 11.5435ZM3.94505 18.508C3.0989 18.508 2.56044 17.9966 2.56044 17.126V16.3099L4.54945 14.5143C5.31868 13.8179 5.83516 13.3717 6.50549 13.3717C7.17582 13.3717 7.74725 13.8396 8.53846 14.5252L9.8022 15.6243L13.5165 12.327C14.4615 11.4891 15.1538 10.9341 15.956 10.9341C16.7802 10.9341 17.4835 11.4782 18.4066 12.327L21.4396 15.1672V17.126C21.4396 17.9966 20.9011 18.508 20.033 18.508H3.94505Z",
            fill: "#D0D6E1",
            fillRule: "evenodd"
        })
    }));
});
var ImageFallbackSvg$1 = ImageFallbackSvg;
ImageFallbackSvg.displayName = "ImageFallbackSvg";

export { ImageFallbackSvg, ImageFallbackSvg$1 as default };
